import * as React from 'react';
import { Rating, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { IFeedback } from '../models';

export const createFeedbacksTableData = (feedback: IFeedback) => {
  console.log('feedback', feedback);
  return {
    date: dayjs(feedback.created_at).format('hh:mm A MM/D/YYYY'),
    zone: <Typography variant="body2">{feedback.zone_code}</Typography>,
    // It would be good that feedback API response can include below info
    name: feedback.name,
    email: feedback.email,
    phone: feedback.phone,
    message: <Typography variant="body2">{feedback.message}</Typography>,
    rating: feedback.rating && (
      <Rating
        value={feedback.rating}
        readOnly
        size="small"
        sx={{
          marginLeft: 'auto',
        }}
      />
    ),
  };
};

export const convertFeedbacksToTableData = (feedbacks: Array<IFeedback>) => {
  return feedbacks.map((feedback) => createFeedbacksTableData(feedback));
};
